import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';
import React from 'react';
import { useRole, Role } from '../hooks/useRole';
import { Navigate } from 'react-router-dom';

export const ProtectedRoute = ({ 
  children, 
  requiredRole 
}: { 
  children: React.ReactNode;
  requiredRole?: Role;
}) => {
  const { isLoaded, isEditor } = useRole();

  if (!isLoaded) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  return (
    <>
      <SignedIn>
        {requiredRole === 'editor' && !isEditor ? (
          <Navigate to="/" replace />
        ) : (
          children
        )}
      </SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
};
